export default {
  user: {
    username: null,
    email: null,
    oldPassword: null,
    password: null,
  },
  isAdmin: false,
  loggedIn: null,
  challenge: null,
};
